/**
 * 基础路由服务
 * */
/**路由懒加载*/

/*注册页面*/
const registerPage = resolve => {
    import('@/views/registerPage/index').then(module => {
        resolve(module)
    })
}

/*找回密码页面*/
const resetPasswordPage = resolve => {
    import('@/views/resetPasswordPage/index').then(module => {
        resolve(module)
    })
}

export default [
    {
        path: '/register',
        component: registerPage,
        hidden: true,
    },
    {
        path: '/resetPassword',
        component: resetPasswordPage,
        hidden: true,
    },
]
